<template>
  <ul class="fa-ul">

    <!--<li v-for="(link, label) in listing.links" :key="label">-->
    <!--<span class="fa-li" ><i :class="getIconClass()"></i></span>-->
    <!--<a :href="link">{{label}}</a>-->
    <!--</li>-->

    <li v-for="item in items" :key="item.name">
      <span class="fa-li"><i :class="getIconClass(item)"></i></span>
      <a v-if="item.url"
         :href="item.url"
         :target="item.action === 'popup' ? item.target : ''"
         :title="item.title || ''"
         :class="item.ignore ? 'ignoreTranslate' : ''"
      >{{item.name}}
      </a>
      <span v-else :class="item.ignore ? 'ignoreTranslate' : ''">{{item.name}}</span>
    </li>
  </ul>
</template>

<script>

  import {cpixdomain} from "../../config";

  export default {
    data() {
      return {
        items: []
      }
    },
    methods: {
      getIconClass(item) {
        let name = item.icon;
        switch (name) {
          case 'download':
            return 'fas fa-download';
          case 'code':
            return 'fas fa-code';
          case 'mobile':
            return 'fas fa-mobile-alt';
          case 'phone':
            return 'fas fa-phone';
          case 'youtube':
            return 'fab fa-youtube';
          case 'photo':
            return 'fas fa-images';
          case 'qr':
            return 'fas fa-qrcode';
          default:
            return 'fas fa-link';
        }
      }
    },
    watch: {
      listing(val) {
        let vm = this;
        vm.items = [
          {name: 'Branded', url: val.links.branded, icon: '', action: 'popup', target: '_blank'},
          {name: 'Unbranded', url: val.links.unbranded, icon: '', action: 'popup', target: '_blank'},
          {name: 'Strict', url: val.links.strict, icon: '', action: 'popup', target: '_blank'},
          {name: 'Agent Gallery', url: val.links.agentGallery, icon: 'photo', action: 'popup'},
          {name: 'Embeded Code', url: val.links.embededCode, icon: 'code', action: 'popup'},
          {name: "LeadBee: " + ` ${val.links.leadBee.phone} ext. ${val.links.leadBee.extension}`, url: null, icon: 'phone', action: null, ignore: true},
          {name: `Shortcode/Keyword: ${val.links.shortcode.shortcode} /  ${val.links.shortcode.keyword}`, url: null, icon: 'phone', action: null, ignore: true},
          {name: `QR Code`, url: `${cpixdomain}/aspen/manageqr.htm?tourid=${val.id}&style=listing#tabs-2`, icon: 'qr', action: null},
        ];

        val.videos.youtube.forEach(v => {
          vm.items.push(
            {name: v.title, url: v.link, icon: 'youtube', title: v.description, ignore: true}
          )
        });
      }
    },
    props: ['listing']
  }
</script>

<style scoped>

  .fa-ul {
    margin-left: 1.5em;
  }

  li {
    color: #93C83E;
  }

  li a {
    color: #2c3e50;
    display: inline-block;
    width: 100%;
    padding: 10px 0;
    cursor: pointer;
  }

  li:hover, li:hover span {
    background: #F5F5F5;
  }

  li span {
    color: #2c3e50;
    display: inline-block;
    padding: 10px 0;
  }

  li span.fa-li {
    color: #93C83E;
    padding: 10px 0;
  }
</style>